module.exports = __webpack_public_path__ + "static/media/damlag_480.83621ed3.jpg";